import React from 'react';
import FeatherIcon from 'feather-icons-react';
import theme from 'styles/theme';
import { makeFailUserMessage } from '../../constants';
import {
  DATA_LINKAGE_ERR_BTN_CASE,
  statusActions,
  updateStatusActions,
} from '../constants';
import ROUTE_PATH from 'routes/config';
import { requestApi } from 'utils/request';
import { TAB_VALUES } from '../constants';
import { COMMON_ERR_MESSAGE } from 'constants/message';
import { useNavigate } from 'react-router-dom';
import { DataListWrapper } from './style';
import qs from 'qs';

const DataList = ({
  dataList,
  setDataList,
  setModalData,
  afterDelete,
  tabValue,
}) => {
  const navigate = useNavigate();

  // 문의하기 페이지로 이동
  const goToQnAPage = () => {
    navigate(ROUTE_PATH.serviceCenter.qnaListPage + '?tab=QnA');
  };

  // 연동 판매몰 수정 페이지로 이동
  const goToEditPage = item => {
    if (item.interlockOpenYn === 'N') {
      // 연동대기 & 오픈예정 일 경우
      navigate(ROUTE_PATH.mypage.dataLinkageModify, {
        state: { tabValue: tabValue, item: item, type: 'waiting' },
      });
    } else {
      navigate(ROUTE_PATH.mypage.dataLinkageModify, {
        state: { tabValue: tabValue, item: item },
      });
    }
  };

  // 데이터 연동(QR 인증 입력) 페이지로 이동: 무조건 주계정
  const goToQRStep = item => {
    const queryString = qs.stringify({
      mode: 'modify',
      seq: item.businessDataProviderMallMappingSeq,
      mallSeq: item.mallSeq,
      type: 'main',
    });
    navigate(
      `${ROUTE_PATH.mypage.dataLinkageDataInterlockRequest}?${queryString}`,
      {
        state: {
          step: 'QRStep',
        },
      }
    );
  };

  // 연동 삭제 버튼 클릭
  const onClickDeleteBtn = item => {
    // 대출 진행중이지 않은 경우
    setModalData({
      contents: <DeleteModalContents item={item} />,
      cancelBtnName:
        tabValue === TAB_VALUES.MALL_INTERLOCK ? '연동 중지 하기' : '닫기',
      onClickCancelBtn: () =>
        tabValue === TAB_VALUES.MALL_INTERLOCK
          ? goToEditPage(item)
          : setModalData(null),
      confirmBtnName: '삭제',
      onClickConfirmBtn: () => fetchInterlockedItem(item),
    });
  };

  // 모달 공통 처리 함수: 닫기 및 새로고침
  const closeAndReload = () => {
    setModalData(null);
    window.location.reload();
  };

  // 2차인증 정보 api
  const fetchSecondAuthInfo = async item => {
    try {
      const res = await requestApi({
        url: `/v1/au/second-auth?secondAuthHash=${item.secondAuthHash}`,
        method: 'GET',
      });

      const { success, 'error-no': errorNo, message } = res;
      if (success) {
        // 2차인증 입력 페이지로 이동
        navigate(ROUTE_PATH.mallSecondAuth + `?hash=${item.secondAuthHash}`);
      } else {
        if (errorNo === 10000) {
          setModalData({
            contents: message,
            confirmBtnName: '재요청',
            cancelBtnName: '취소',
            onClickConfirmBtn: async () => {
              await fetchRequestScraping(
                item.businessDataProviderMallMappingSeq
              );
            },
          });
        } else {
          setModalData({
            contents: message,
            confirmBtnName: '확인',
            onClickConfirmBtn: () => {
              setModalData(null);
            },
          });
        }
      }
    } catch (error) {
      console.error(error);
      if (error.response.data.errorCode === 500) {
        setModalData({
          contents: error.response.data.message,
        });
      } else {
        setModalData({
          contents: COMMON_ERR_MESSAGE,
        });
      }
    }
  };

  // 판매몰 연동 삭제 api
  const fetchInterlockedItem = async item => {
    try {
      const url =
        tabValue === TAB_VALUES.MALL_INTERLOCK
          ? `/v1/au/data-provider-mall/interlock-main-mall/${item.businessDataProviderMallMappingSeq}`
          : `/v1/au/data-provider/${item.dataProviderSeq}/interlock/business`;
      const res = await requestApi({
        url,
        method: 'DELETE',
      });

      if (res.success) {
        setModalData({
          contents: '연동 정보가 삭제되었어요.',
          onClickCloseBtn: () => {
            setModalData(null);
            afterDelete();
          },
        });
      }
    } catch (error) {
      console.error(error);
      if (error.response.data.errorCode === 500) {
        setModalData({
          contents: error.response.data.message,
        });
      } else {
        setModalData({
          contents: COMMON_ERR_MESSAGE,
        });
      }
    }
  };

  // 스크래핑 요청 API 호출
  const fetchRequestScraping = async seq => {
    try {
      const res = await requestApi({
        url: `/v1/au/data-provider-mall/requestScraping/${seq}`,
        method: 'POST',
      });

      if (res.success) {
        setModalData({
          contents: '재요청이 완료되었습니다.',
          onClickCloseBtn: closeAndReload,
        });
      } else {
        setModalData({
          contents: res.message,
          onClickCloseBtn: closeAndReload,
        });
      }
    } catch (error) {
      // 500 에러 포함: 정제되지 않은 에러 메시지 존재
      setModalData({
        contents: COMMON_ERR_MESSAGE,
        onClickCloseBtn: closeAndReload,
      });
      console.error(error);
    }
  };

  // 연동 실패 안내문
  const FailMessageBox = ({ item }) => {
    return (
      <div className="failMessageBox">
        <p className="title">{makeFailMessageTitle(item)}</p>
        {item.isOpen && (
          <div className="contents">
            {makeFailMessageContents(item)}
            {makeFailMessageBtn(item)}
          </div>
        )}
        <button
          type="button"
          className={item.isOpen ? 'foldInfo' : 'openInfo'}
          onClick={() => {
            setDataList(
              dataList.map(data => ({
                ...data,
                isOpen:
                  item.businessDataProviderMallMappingSeq ===
                  data.businessDataProviderMallMappingSeq
                    ? !data.isOpen
                    : data.isOpen,
              }))
            );
          }}
        >
          <FeatherIcon icon="chevron-down" size={20} />
        </button>
      </div>
    );
  };

  // 연동 실패 안내문 - 제목 생성
  const makeFailMessageTitle = item => {
    return (
      <>
        <img alt="알림 표시" src="/images/icons/info.svg" />
        {item.mallInterlockStatusCd === 'WAIT' ? (
          <span>
            연동을 위해 <span>2차인증을 진행</span>해 주세요.
          </span>
        ) : (
          <span>
            연동에 실패했어요. <span>실패사유를 확인</span>해 주세요.
          </span>
        )}
      </>
    );
  };

  // 연동 실패 안내문 - 상세 내용 생성
  const makeFailMessageContents = item => {
    const {
      errorCode,
      secondAuthCategoryCd,
      mallName,
      secondAuthHash,
      mallInterlockStatusCd,
      anotherBusinessRegistrationNumber,
      errorMessage,
    } = item;

    return secondAuthHash ? (
      // 2차 인증 필요
      <p>
        판매몰의 2차 인증이 전송되었습니다.
        <br />
        <strong>유효시간 3분 이내로 2차 인증을 진행</strong>해 주세요.
      </p>
    ) : // 연동 불가 상태
    mallInterlockStatusCd === 'UNAVAILABLE' &&
      anotherBusinessRegistrationNumber ? (
      <p>
        가입하신 사업자 번호와 연동하려는 판매몰의 사업자번호가 일치하지
        않습니다.
        <br />
        <strong>데이터 연동을 위해서는 두 번호가 동일</strong>해야 합니다.
        일치하는 사업자 번호로 다시 시도해 주세요.
        <br />
        <br />
        <span className="bulletPoint">
          현재 <strong>{mallName}</strong> 판매몰에 등록된 사업자 번호
          <br />
          <strong>{anotherBusinessRegistrationNumber}</strong>
        </span>
      </p>
    ) : (
      // 에러 케이스
      <p>
        {makeFailUserMessage(
          errorCode,
          'dataLinkageManage',
          secondAuthCategoryCd
        ) ||
          errorMessage ||
          makeFailUserMessage('etc', 'dataLinkageManage')}
      </p>
    );
  };

  // 연동 실패 안내문 - 액션 버튼 생성
  const makeFailMessageBtn = item => {
    const btnType =
      Object.keys(DATA_LINKAGE_ERR_BTN_CASE).find(name =>
        DATA_LINKAGE_ERR_BTN_CASE[name].includes(item.errorCode)
      ) || (item.secondAuthHash ? 'enterSecondAuth' : 'askInquire');
    const chooseBtnData = () => {
      switch (btnType) {
        case 'captureRequest':
          return {
            text: '캡차 인증 재요청하기',
            onClick: async () => {
              await fetchRequestScraping(
                item.businessDataProviderMallMappingSeq
              );
            },
          };
        case 'secondAuthRequest':
          return {
            text: '2차 인증 재요청하기',
            onClick: async () => {
              await fetchRequestScraping(
                item.businessDataProviderMallMappingSeq
              );
            },
          };
        case 'askInquire':
          return {
            text: '1:1 문의하기',
            onClick: () => {
              goToQnAPage();
            },
          };
        case 'editMallAccountInfo':
          return {
            text: '계정 정보 수정하기',
            onClick: () => {
              goToEditPage(item);
            },
          };
        case 'scrapingRequest':
          return {
            text: '연동 재요청하기',
            onClick: async () => {
              await fetchRequestScraping(
                item.businessDataProviderMallMappingSeq
              );
            },
          };
        case 'enterSecondAuth':
          return {
            text: '2차 인증 입력하기',
            onClick: async () => {
              await fetchSecondAuthInfo(item);
            },
          };
        case 'secondAuthOrQRAuth':
          if (item.secondAuthCategoryCd !== 'SAM200') {
            return {
              text: '2차 인증 재요청하기',
              onClick: async () => {
                await fetchRequestScraping(
                  item.businessDataProviderMallMappingSeq
                );
              },
            };
          } else {
            return {
              text: 'QR OTP 인증 하기',
              onClick: () => goToQRStep(item),
            };
          }
      }
    };

    return (
      btnType !== 'noButton' && (
        <button type="button" onClick={chooseBtnData().onClick}>
          {chooseBtnData().text}
        </button>
      )
    );
  };

  // 연동 삭제 모달 컨텐츠
  const DeleteModalContents = ({ item }) => {
    return (
      <div style={{ textAlign: 'center' }}>
        <span style={{ color: theme.color.blue }}>
          {item.mallName || item.dataProviderName}
        </span>
        의
        <br />
        연동 정보를 정말 삭제하시겠어요?
        <ul style={{ marginTop: '20px' }}>
          <li>삭제 시 복구가 불가해요</li>
          <li>일시적으로 연동이 불필요한 경우, 연동 중지가 가능해요</li>
          <li>
            '연동 완료' 상태에서 삭제 시 금융기관 심사에 영향을 줄 수 있습니다
          </li>
        </ul>
      </div>
    );
  };

  return (
    <DataListWrapper>
      {dataList.map((item, index) => {
        // '연동대기' 상태일 때 데이터 연동 오픈 여부가 '오픈예정'인 경우 활성화
        updateStatusActions(
          item.mallInterlockStatusCd === 'WAIT' && item.interlockOpenYn === 'N'
        );
        return (
          <li key={`card_item_${index}`}>
            <label
              className={
                item.mallInterlockStatusCd || item.providerInterlockStatusCd
              }
            >
              {item.mallInterlockStatusNm || item.providerInterlockStatusNm}
            </label>
            <dl>
              <dt>{item.mallName || item.dataProviderName}</dt>
              <dd>{item.mainAccountId || item.dataProviderId}</dd>
            </dl>
            <div className="buttonGroup">
              <button
                type="button"
                onClick={() => {
                  goToEditPage(item);
                }}
                disabled={
                  !statusActions[
                    item.mallInterlockStatusCd || item.providerInterlockStatusCd
                  ]?.modify
                }
              >
                수정
              </button>
              <button
                type="button"
                onClick={() => onClickDeleteBtn(item)}
                disabled={
                  !statusActions[
                    item.mallInterlockStatusCd || item.providerInterlockStatusCd
                  ]?.delete
                }
              >
                삭제
              </button>
            </div>
            {/* 연동 실패, 연동 불가일 때 안내 메시지 */}
            {(item.mallInterlockStatusCd === 'FAIL' ||
              item.mallInterlockStatusCd === 'UNAVAILABLE' ||
              (item.mallInterlockStatusCd === 'WAIT' &&
                item.secondAuthHash)) && <FailMessageBox item={item} />}
          </li>
        );
      })}
    </DataListWrapper>
  );
};

export default DataList;
